import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { useCart } from "../context/CartContext";
import { imgUrl } from "../admin/adminApi";
import { Button } from "./ui/button";
import { Plus, Check, Tag, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PackageCard = ({ p }) => {
  const { addToCart, items } = useCart();
  const inCart = items.find((i) => i.name === p.name);
  const pct = p.original_price ? Math.round((1 - p.price / p.original_price) * 100) : 0;
  return (
    <div className="svc-card bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl ring-1 ring-black/5 flex flex-col">
      <div className="img-zoom-wrap relative h-48 overflow-hidden">
        <img src={imgUrl(p.image)} alt={p.name} className="img-zoom w-full h-full object-cover" />
        {pct > 0 && <span className="absolute top-3 right-3 bg-accent text-white text-xs font-bold px-2.5 py-1 rounded-full shadow">{pct}% OFF</span>}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-display text-xl font-bold text-gray-900">{p.name}</h3>
        <p className="text-sm text-gray-600 mt-2 flex-1">{p.description}</p>
        {Array.isArray(p.services) && p.services.length > 0 && <p className="text-xs text-gray-400 mt-2">Includes: {p.services.join(", ")}</p>}
        <div className="flex items-center gap-2 mt-3"><span className="font-bold text-primary text-lg">₹{p.price}</span>{p.original_price ? <span className="line-through text-gray-400 text-sm">₹{p.original_price}</span> : null}</div>
        <Button onClick={() => addToCart({ name: p.name, price: p.price, type: "package" })} disabled={!!inCart} className="mt-3 bg-primary hover:bg-primary/90 rounded-full h-10 font-semibold">
          {inCart ? <><Check className="w-4 h-4 mr-1" /> Added</> : <><Plus className="w-4 h-4 mr-1" /> Add to Cart</>}
        </Button>
      </div>
    </div>
  );
};

const PackagesPage = () => {
  const [packages, setPackages] = useState([]);
  const [offers, setOffers] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/packages`).then((r) => setPackages(r.data)).catch(() => {});
    axios.get(`${API}/offers`).then((r) => setOffers(r.data)).catch(() => {});
  }, []);
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh] max-w-7xl mx-auto px-4 md:px-6 lg:px-12 py-12 md:py-16">
        <p className="text-primary font-semibold tracking-wide uppercase text-sm">Best Value</p>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-2">Packages & Deals</h1>
        <div className="w-20 h-1 bg-accent rounded-full mt-4" />

        {offers.length > 0 && (
          <div className="grid sm:grid-cols-2 gap-4 mt-8">
            {offers.map((o) => (
              <div key={o.id} className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary to-primary/80 p-5 text-white flex items-center justify-between">
                <div className="absolute -right-6 -top-6 w-24 h-24 rounded-full bg-white/10" />
                <div className="relative"><div className="flex items-center gap-2 text-white/90 text-sm"><Tag className="w-4 h-4 text-accent" /> Limited Offer</div><div className="font-display text-xl font-bold mt-1">{o.title}</div><p className="text-white/80 text-sm mt-0.5">{o.description}</p></div>
                <div className="relative text-center"><div className="text-3xl font-extrabold">{o.discount_value}{o.discount_type === "percent" ? "%" : "₹"}</div><div className="font-mono bg-white/20 rounded px-2 py-0.5 text-xs mt-1">{o.code}</div></div>
              </div>
            ))}
          </div>
        )}

        <div className="flex items-center gap-2 mt-10 mb-6"><Sparkles className="w-5 h-5 text-accent" /><h2 className="font-display text-2xl font-bold text-gray-900">Combo Packages</h2></div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((p) => <PackageCard key={p.id} p={p} />)}
        </div>
        {packages.length === 0 && <p className="text-gray-500 py-10">No packages available right now.</p>}
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
};

export default PackagesPage;
